import { useState, useEffect } from "react";
import {
    Drawer,
    Box,
    IconButton,
    Typography,
    TextField,
    Button,
    Paper,
    Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTheme } from "@mui/material/styles";
import { pageStyles } from "../../Styles/pageStyles";
import { commonServices } from "../../Services/commonServices";
import { apiHandler, widthData } from "@shared/Functions/apiHandler";
import BvnVerified from "./bvnVarified";


export default function BVNDrawer({ open, setData, onClose2 }) {
    const theme = useTheme();
    const classes = pageStyles(theme);

    const [bvn, setBvn] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [bvnVerified, setBvnVerified] = useState(false);
    const [loader, setLoader] = useState(false);

    // format as user types: auto space after every 4 digits (visual only)
    function formatBVN(raw) {
        const digits = raw.replace(/\D/g, "").slice(0, 11);
        return digits.replace(/(.{4})/g, "$1 ").trim();
    }

    // function handleChange(e) {
    //     const raw = e.target.value;
    //     setBvn(raw.replace(/\s/g, ""));
    // }

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // allows only digits
        if (value.length <= 10) {
            setBvn(value);
        }
    };


    function handleAccountChange(e) {
        const raw = e.target.value;
        setAccountNumber(raw.replace(/\s/g, ""));
    }

    const onVerify = async () => {
        let payload = {
            "accountNumber": bvn,
            "bankCode": accountNumber
        }
        const res = await commonServices.verifyBVN(payload);
        apiHandler(res, classes.successToast, true);
        if (res?.status === 200) {
            setBvnVerified(true);
        }
    }

    const modalProps = {
        onBackdropClick: (e) => {
            e.stopPropagation();
        },
    };



    const getWalletStatus = async () => {
        const res = await commonServices.getWalletStatus();
        apiHandler(res);
        if (res?.status) {
            if (res?.data?.data?.isWalletEnabled) {
                setBvnVerified(true);
            }
        }
    }

    useEffect(() => {
        if (open) {
            getWalletStatus();
        }
    }, [open]);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose2}
            ModalProps={modalProps}
            slotProps={{
                paper: {
                    sx: {
                        width: { xs: "100%", sm: 420 },
                        maxWidth: widthData,
                        bgcolor: "#FFFDF8",
                        boxShadow: 6,
                        borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                        p: 2,
                    },
                },
            }}
        >

            <BvnVerified
                open={bvnVerified}
                onClose={() => setBvnVerified(false)}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <IconButton onClick={onClose2} size="small">
                    {setData}
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    BVN Verification
                </Typography>
            </Box>

            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Secure Your Account
            </Typography>
            <Typography sx={classes.darkTextsmd}>
                Please enter your 10 digit Bank Verification Number (BVN) to activate wallet
            </Typography>

            <Typography sx={{ ...classes.greyTextsmd, mt: 2 }}>
                Bank Verification Number (BVN)
            </Typography>

            <TextField
                placeholder="Enter here"
                value={formatBVN(bvn)}
                onChange={handleChange}
                fullWidth
                size="small"
                slotProps={{
                    input: {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 10,
                    },
                }}
                sx={classes.inputField}
            />
            <Typography sx={{ ...classes.greyTextsmd, mb: 2 }}>
                Auto space after every 4 digits: {bvn.length}/10 digits
            </Typography>

            <Typography sx={{ ...classes.greyTextsmd }}>
                Bank Code
            </Typography>
            <TextField
                placeholder="Enter here"
                value={accountNumber}
                onChange={handleAccountChange}
                fullWidth
                size="small"
                sx={classes.inputField}
                slotProps={{
                    input: {
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 14,
                    },
                }}
            />

            <Button
                variant="contained"
                fullWidth
                sx={{ my: 2 }}
                onClick={onVerify}
            >
                Verify BVN
            </Button>

            <Paper elevation={0} sx={classes.infoDiv}>
                Your BVN is used only for identity verification. It will remain secure and is encrypted using bank-grade security.
            </Paper>

            <Box sx={classes.bvnCheck}>
                <Box sx={classes.flex_c}>
                    <CheckCircleOutlineIcon fontSize="small" sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Bank-grade encryption</Typography>
                </Box>
                <Box sx={classes.flex_c}>
                    <CheckCircleOutlineIcon fontSize="small" sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Compliant with CBN regulations</Typography>
                </Box>
                <Box sx={classes.flex_c}>
                    <CheckCircleOutlineIcon fontSize="small" sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Used only for verification</Typography>
                </Box>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Box sx={classes.bvnSteps}>
                <Typography sx={{ ...classes.themeTextsmd, fontWeight: 600 }}>
                    Don't have a BVN?
                </Typography>

                <Box sx={{ mt: 2 }}>
                    <Typography sx={classes.themeTextsmd}>
                        You can get your BVN by dialing *565*0# from any phone number linked to your bank account.
                    </Typography>
                    <Typography sx={classes.themeTextsmd}>• BVN is free and takes about 10 minutes to generate</Typography>
                    <Typography sx={classes.themeTextsmd}>• Available 24/7 from any network</Typography>
                    <Typography sx={classes.themeTextsmd}>• Same BVN works for all Nigerian banks</Typography>
                </Box>
            </Box>

        </Drawer>
    );
}
